import moment from "moment/moment";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import info from "../../../data/enneagramme.json";
import { checkIfAllowedToRespond, findNotResponded, isAllResponded, onCompleted } from "../formHelper";
import FooterPagesNavigation from "../../../components/FooterPagesNavigation";

export default function QuestionEnneagramme({}) {
  const navigate = useNavigate();
  const [reponses, setReponses] = useState(
    localStorage.getItem("reponses")
      ? JSON.parse(localStorage.getItem("reponses"))
      : [
          ...info.forms.map((form, group) =>
            form.questions.map((e, key) => {
              return {
                group: group,
                number: key,
                scoreGroup: e.group,
                score: undefined,
              };
            })
          ),
        ]
  );
  const [page, setPage] = useState(1);
  const hash = useLocation().hash;

  useEffect(() => {
    checkIfAllowedToRespond(2)
      .then()
      .catch((err) => navigate("/notAllowed"));
  }, []);

  useEffect(() => {
    setPage(parseInt(hash.split("#")[1]));
  }, [hash]);

  useEffect(() => {
    for (let index = 0; index < reponses[page - 1].length; index++) {
      const element = reponses[page - 1][index];
      if (element.score === undefined && index === 0) {
        window.scrollTo({top: 0})
        break;
      } else if (element.score === undefined) {
        document.getElementById("card_" + page + "_" + index).scrollIntoView({ behavior: "smooth" });
        break;
      }
    }
  }, [page]);

  useEffect(() => {
    localStorage.setItem("reponses", JSON.stringify(reponses));
  }, [reponses]);

  return (
    <>
      <div className="flex flex-col items-center p-4 mb-36 pt-14 space-y-5">
        <h1 className="text-3xl">{info.forms[page - 1].title}</h1>
        <p className="text-center">Cochez la case correspondant aux comportements qui vous interpellent.</p>
        <div className="flex flex-col py-10 md:grid md:grid-cols-2 gap-5">
          {info.forms[page - 1].questions.map((question, key) => (
            <div key={question.message} id={"card_" + page + "_" + key} className="flex flex-col max-w-lg p-4 bg-white w-full shadow rounded-lg">
              <p className="text-lg flex-grow">{question.message}</p>
              <div className="flex items-center justify-between h-8 mt-5 text-sm">
                {reponses[page - 1][key].score === undefined && <p className="w-full font-semibold text-center text-red-400">Pas de reponse</p>}
              </div>
              <div className="flex flex-col sm:flex-row items-center justify-center space-y-3 sm:space-y-0 sm:space-x-5 px-4">
                <button
                  onClick={(e) => {
                    let modif = [...reponses];
                    modif[page - 1][key].score = 0;
                    setReponses(modif);
                  }}
                  className={
                    "bg-tansparent px-4 py-2 flex space-x-2 text-palette-orange " +
                    (reponses[page - 1][key].score === 0 ? "border rounded-lg border-palette-orange" : "hover:underline")
                  }
                >
                  {reponses[page - 1][key].score === 0 && (
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
                      <path
                        fillRule="evenodd"
                        d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-1.72 6.97a.75.75 0 10-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 101.06 1.06L12 13.06l1.72 1.72a.75.75 0 101.06-1.06L13.06 12l1.72-1.72a.75.75 0 10-1.06-1.06L12 10.94l-1.72-1.72z"
                        clipRule="evenodd"
                      />
                    </svg>
                  )}
                  {reponses[page - 1][key].score !== 0 && (
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  )}
                  <p>Ce n'est pas moi</p>
                </button>
                <button
                  onClick={(e) => {
                    let modif = [...reponses];
                    modif[page - 1][key].score = 1;
                    setReponses(modif);
                  }}
                  className={
                    "bg-tansparent px-4 py-2 flex space-x-2 text-palette-green " +
                    (reponses[page - 1][key].score === 1 ? "border rounded-lg border-palette-green" : "hover:underline")
                  }
                >
                  {reponses[page - 1][key].score === 1 && (
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
                      <path
                        fillRule="evenodd"
                        d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z"
                        clipRule="evenodd"
                      />
                    </svg>
                  )}
                  {reponses[page - 1][key].score !== 1 && (
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  )}
                  <p>Ça m'interpelle</p>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
      <FooterPagesNavigation
        pages={info.forms.length}
        onEnd={() => onCompleted(reponses, navigate)}
        endDisable={!isAllResponded(reponses)}
        onClickDisable={() => findNotResponded(reponses, navigate)}
        textDisable="Réponses manquantes"
      />
    </>
  );
}
